"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTheme = exports.dark = exports.light = void 0;
var styles_1 = require("@material-ui/core/styles");
var light_1 = require("./light");
Object.defineProperty(exports, "light", { enumerable: true, get: function () { return light_1.theme; } });
var dark_1 = require("./dark");
Object.defineProperty(exports, "dark", { enumerable: true, get: function () { return dark_1.theme; } });
function createMuiTheme(go, direction) {
    return Object.assign((0, styles_1.createMuiTheme)({
        direction: direction,
        props: {
            MuiButtonBase: {
                disableRipple: true,
                disableTouchRipple: true,
            },
            MuiCheckbox: {
                disableRipple: true,
                disableTouchRipple: true,
                disableFocusRipple: true,
            },
            MuiRadio: {
                disableRipple: true,
                disableTouchRipple: true,
                disableFocusRipple: true,
            },
            MuiCard: {
                elevation: 0,
            },
            MuiInputLabel: {
                disableAnimation: true,
                variant: 'standard',
                // материал скрывает плейсхолдер, нам это не надо
                // @ts-ignore
                shrink: null,
            },
        },
        overrides: {
            MuiCssBaseline: __assign({}, go.mixins.typography.fontFaces),
            MuiCard: {
                root: {
                    borderRadius: 24,
                },
            },
            MuiCardContent: {
                root: {
                    padding: 24,
                },
            },
        },
    }), {
        go: go,
    });
}
exports.createMuiTheme = createMuiTheme;
